import FutureModal from './future-modal-container'

export default FutureModal
